import { defineCustomElement } from 'vue';
import NocwareChatWidget from './NocwareChatWidget.ce.vue';
import { withNwStyles, configureWcApp } from './wc-config';

const NocwareChatWidgetElement = defineCustomElement(withNwStyles(NocwareChatWidget), {
    shadowRoot: true,
    configureApp: configureWcApp,
});

customElements.define('nw-chat-widget', NocwareChatWidgetElement);
